import { useEffect, useRef, useState } from 'react';
import { IoChevronDown, IoChevronForward } from 'react-icons/io5';
import ReportRow from './ReportRow';
import './reports.css';

/**
 * Consecutive chapters read together, collapsed to one row ("Genesis 1–3").
 * Expanding it lists each chapter, which can be edited on its own. In select
 * mode its checkbox selects every chapter in the range.
 */
const ReportRangeRow = ({
  entry,
  showReader,
  selectMode,
  selectedIds,
  onToggleSelect,
  onToggleMany,
  editing,
  editActions
}) => {
  const [open, setOpen] = useState(false);
  const checkboxRef = useRef(null);

  const ids = entry.reports.map((report) => report.id);
  const selectedCount = ids.filter((id) => selectedIds.has(id)).length;
  const all = selectedCount === ids.length;

  useEffect(() => {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate = selectedCount > 0 && !all;
    }
  }, [selectedCount, all]);

  return (
    <li className={`report-row report-row--range ${all ? 'is-selected' : ''}`}>
      <div className="report-range-header">
        {selectMode && (
          <input
            ref={checkboxRef}
            type="checkbox"
            className="report-range-check"
            checked={all}
            aria-label={`Select ${entry.book} ${entry.from}–${entry.to}`}
            onChange={() => onToggleMany(ids, !all)}
          />
        )}
        <button
          type="button"
          className="report-row-main"
          aria-expanded={open}
          onClick={() => setOpen((value) => !value)}
        >
          <span className="report-ref">{entry.book} {entry.from}–{entry.to}</span>
          <span className="report-count">{entry.reports.length} chapters</span>
          {showReader && entry.reader?.name && <span className="report-reader">{entry.reader.name}</span>}
          {open ? <IoChevronDown aria-hidden="true" /> : <IoChevronForward aria-hidden="true" />}
        </button>
      </div>

      {open && (
        <ul className="report-list report-list--nested">
          {entry.reports.map((report) => (
            <ReportRow
              key={report.id}
              report={report}
              nested
              showReader={false}
              selectMode={selectMode}
              selected={selectedIds.has(report.id)}
              onToggleSelect={onToggleSelect}
              editing={editing}
              editActions={editActions}
            />
          ))}
        </ul>
      )}
    </li>
  );
};

export default ReportRangeRow;
